import {Box, Grid, Typography} from "@mui/material";
import ProductCard from "./ProductCard";
import {Map, MusicNote, CurrencyYen, Adjust, Psychology, Public, Spellcheck} from "@mui/icons-material";

export default function AppBody() {
  return (
    <>
      <Typography fontFamily={'"M PLUS Rounded 1c", sans-serif'}> ▽・ω・▽ b </Typography>

      <Box margin={1}>
        <Typography variant={"h6"}> Self-Use Tools </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"PoChat"} link={"https://pochat.showkami.com"} icon={<Psychology />} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"FocusHub"} link={"https://focushub.showkami.com"} icon={<Adjust />} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"EngLens"} link={"https://englens.showkami.com"} icon={<Spellcheck />} />
          </Grid>
        </Grid>
      </Box>

      <Box margin={1}>
        <Typography variant={"h6"}> Apps </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"Music theory"} link={"https://music.showkami.com"} icon={<MusicNote />} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"Income tax"} link={"https://income-tax.showkami.com/"} icon={<CurrencyYen />} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"Geolocation"} link={"https://geolocation.showkami.com"} icon={<Map />} />
          </Grid>
          <Grid item xs={6} sm={4}>
            <ProductCard appName={"Geography App"} link={"https://geography.showkami.com"} icon={<Public />} />
          </Grid>
        </Grid>
      </Box>

    </>
  )
}